module.exports = __webpack_public_path__ + "static/media/1POLICY37.94ecf9cb.jpg";